import { SEC_ApiCall, SEC_DataApiPost } from '../func.js';

/**
 * Load the add-cover editor payload for one rota and one date.
 * @param {string} masterRotaId - Stable rota-family identifier.
 * @param {string} overrideDate - YYYY-MM-DD date string.
 * @returns {Promise<object>} API response payload.
 */
export function getRotaOverrideEditor(masterRotaId, overrideDate) {
  return SEC_ApiCall('rotas/override/editor', { masterRotaId, overrideDate });
}

/**
 * Save one single-block cover override for a rota/date.
 * @param {object} payload - { masterRotaId, overrideDate, blockId, userId }
 * @returns {Promise<object>} API response payload.
 */
export function saveRotaOverride(payload) {
  return SEC_DataApiPost('rotas/override/save', JSON.stringify(payload), {});
}
